import styled, { css } from 'styled-components'

export const Row = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
    padding: ${theme.space['12']} ${theme.space['16']};
    background: ${theme.colors.white};
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    max-width: 72rem;
    width: 100%;
    cursor: pointer;
  `,
)

export const IconWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    color: ${theme.colors.black500};
  `,
)

export const RightSection = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    margin-left: auto;
    flex-shrink: 0;
    height: ${theme.space['32']};
  `,
)
